import type { ClientType, SignupJoinPathType } from "../../../store/apis/auth/interface";

export interface WorkspaceFormData {
  companyName: string;
  businessNumber: string;
  countryCodeItemName: string;
  tel: string;
  telPrefix: string;
  fax: string;
  faxPrefix: string;
  postalCode: string;
  streetAddress: string;
  region: string;
  locality: string;
  city: string;
  apartment: string;
  state: string;
  postal: string;
  country: string;
  timezoneCity: string;
  timezoneGmtOffset: number;
  mainCategoryCodeItemNames: string[];
}

export interface BaseCompanyRequestBody {
  companyType: ClientType;
  countryName: string;
  countryCodeItemName: string;
  businessNumber: string;
  companyName: string;
  tel: string;
  telPrefix: string;
  postalCode: string;
  streetAddress: string;
  region?: string;
  locality?: string;
  city: string;
  gmtOffset: number;
  industryCodeItemNames: string[];
  mainCategoryCodeItemNames: string[];
  joinPath?: SignupJoinPathType;
  joinPathDescription?: string;
  faxPrefix?: string;
  fax?: string;
  autoApproveNewMembers: boolean;
}

export const WORKSPACE_FORM_DEFAULTS: WorkspaceFormData = {
  companyName: "",
  businessNumber: "",
  countryCodeItemName: "",
  tel: "",
  telPrefix: "",
  fax: "",
  faxPrefix: "",
  postalCode: "",
  streetAddress: "",
  region: "",
  locality: "",
  city: "",
  apartment: "",
  state: "",
  postal: "",
  country: "",
  timezoneCity: "",
  timezoneGmtOffset: 0,
  mainCategoryCodeItemNames: [],
};